const environmentDomain = window.location.origin;
console.log("environmentDomain", environmentDomain);

const config = () => {
  if (
    environmentDomain === "https://helptest.akead.net" ||
    environmentDomain === "http://localhost:3000"
  ) {
    return {
      VERSION: "1.0.5",
      NAME: "AKEAD-TEST",
      API_URL: "https://authenticationtest.akead.link",
      PARTNER_URL: "https://partnertest.akead.link",
      HELP_URL: "https://apigatetest.akead.xyz/help",
      CODE: "207",
      CONNECTION_CODE: "HELP",
      CHIPER_KEY: "W!Rj7mg6Y6",
    };
  }

  if (environmentDomain === "https://help.akead.net") {
    return {
      VERSION: "1.0.5",
      NAME: "AKEAD-PROD",
      API_URL: "https://authentication.akead.link",
      PARTNER_URL: "https://partner.akead.link",
      HELP_URL: "https://help.akead.link",
      CODE: "207",
      CONNECTION_CODE: "HELP",
      CHIPER_KEY: "W!Rj7mg6Y6",
    };
  }

  console.error("Environment domain unknown:", environmentDomain);
  throw new Error("Geçersiz domain: config() için eşleşen ortam bulunamadı.");
};
console.log("config:", config());
console.log("app-code:", config().CODE);
export default config;


